import { render, staticRenderFns } from "./ContactParent.vue?vue&type=template&id=7e333a24&"
import script from "./ContactParent.vue?vue&type=script&lang=js&"
export * from "./ContactParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports